module.exports = __webpack_public_path__ + "img/tg-pulse-logo.0fa630c6.png";